import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent } from './ui/card';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const LogosCarousel = () => {
  const logos = [
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/pbp8pg54_Comercial%20dove.jpeg',
      alt: 'Comercial Dave'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/ic6ocyyl_logo%20infotecno.png',
      alt: 'Infotecno'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/0vj6u43n_logo%20kong.jpeg',
      alt: 'Kong'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/oz1qc9sg_logo%20mas%20salud.jpeg',
      alt: 'Más Salud'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/8by4okqi_logo%20mycar.jpeg',
      alt: 'Mycar Sur'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/2n6pa1hy_logo%20nak.jpeg',
      alt: 'NAK'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/vnhcz0ng_logo%20neumaticos%20stay.jpeg',
      alt: 'Neumáticos Stay'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/gzavnx0s_logo%20one%20garaje.jpeg',
      alt: 'One Garage'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/ysre7c67_logo-waffel-haus.DCqGHFmF_Z1a9zrj.jpg',
      alt: 'Waffel Haus'
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: true,
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          speed: 2500,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          speed: 2000,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          speed: 2000,
        }
      }
    ]
  };

  return (
    <div className="logos-carousel-container overflow-hidden">
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div key={index} className="px-2 sm:px-4">
            <Card className="hover:shadow-xl transition-all duration-300 bg-white border-2 border-slate-100">
              <CardContent className="p-4 sm:p-6 flex items-center justify-center h-[100px] sm:h-[140px]">
                <img 
                  src={logo.url}
                  alt={logo.alt}
                  className="w-full h-full object-contain"
                  style={{ maxHeight: '80px' }}
                />
              </CardContent>
            </Card>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default LogosCarousel;
